import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonIconButton } from '../IconButton/IconButton.definition';
import { chameleonCodeSnippet } from './CodeSnippet.definition';
import { chameleonTooltipV2 } from '../TooltipV2';
import { chameleonSvg } from '../Svg';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonCodeSnippet({ prefix }), chameleonTooltipV2({ prefix }), chameleonIconButton({ prefix }), chameleonSvg({ prefix }));
}
